/**
 * Master Data A permission keys used by the UI (catalog: `md.<feature>.<action>`; legacy menus 6 Currencies,
 * 12 Chart Of Accounts, 13 Cost Centers, 410 Project Format). The API checks the same keys.
 */
export const financePermissions = {
  currencyView: "md.currency.view",
  currencyCreate: "md.currency.create",
  currencyUpdate: "md.currency.update",
  currencyDelete: "md.currency.delete",
  currencyImport: "md.currency.import",
  currencyExport: "md.currency.export",
  /** Accept an exchange rate outside the currency's min/max range (MA4, audited). */
  rateOverrideRange: "md.rates.override_range",
  accountView: "md.account.view",
  accountCreate: "md.account.create",
  accountUpdate: "md.account.update",
  accountDelete: "md.account.delete",
  accountImport: "md.account.import",
  accountExport: "md.account.export",
  accountGroupView: "md.account_group.view",
  accountGroupCreate: "md.account_group.create",
  accountGroupUpdate: "md.account_group.update",
  accountGroupDelete: "md.account_group.delete",
  costCenterView: "md.cost_center.view",
  costCenterCreate: "md.cost_center.create",
  costCenterUpdate: "md.cost_center.update",
  costCenterDelete: "md.cost_center.delete",
  costCenterImport: "md.cost_center.import",
  costCenterExport: "md.cost_center.export",
  projectView: "md.project.view",
  projectCreate: "md.project.create",
  projectUpdate: "md.project.update",
  projectDelete: "md.project.delete",
  projectImport: "md.project.import",
  projectExport: "md.project.export",
  partyView: "md.party.view",
  partyCreate: "md.party.create",
  partyUpdate: "md.party.update",
  partyDelete: "md.party.delete",
  partyImport: "md.party.import",
  partyExport: "md.party.export",
  paymentTermView: "md.payment_term.view",
  paymentTermCreate: "md.payment_term.create",
  paymentTermUpdate: "md.payment_term.update",
  paymentTermDelete: "md.payment_term.delete",
} as const;
